module.exports = __webpack_public_path__ + "static/media/05(6).eb82f9d1.jpg";